module.exports = __webpack_public_path__ + "img/img43.af723851.png";